@if (open && item) {
  <div
    (click)="onBackdropClick($event)"
    class="fixed inset-0 z-[999] flex items-start justify-center overflow-hidden bg-black/55 px-5 pt-[72px] backdrop-blur-sm">
    <div class="relative flex max-h-[calc(100vh-92px)] w-full max-w-[1000px] flex-col overflow-hidden rounded-2xl border border-neutral-200 bg-white shadow-2xl dark:border-neutral-800 dark:bg-neutral-900">
      <div class="flex items-center justify-between border-b border-neutral-200 px-5 py-4 dark:border-neutral-700">
        <h5 class="text-lg font-semibold text-neutral-900 dark:text-white">Ajustes de Preço</h5>
        <button type="button" (click)="close()" title="Fechar"
          class="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-neutral-200 bg-transparent text-neutral-500 hover:bg-neutral-100 hover:text-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:hover:bg-neutral-800 dark:hover:text-white">
          <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
        </button>
      </div>

      <div class="overflow-auto p-5">
        <div class="mb-4 flex flex-col gap-1.5">
          <div class="text-sm text-neutral-500 dark:text-neutral-400">
            <code class="font-mono text-neutral-900 dark:text-neutral-100">{{ item.productId }}</code> — {{ item.name }}
          </div>
          <div class="flex gap-6 text-sm">
            <span><span class="text-neutral-500 dark:text-neutral-400">Preço original:</span>
              <span class="ml-1 font-mono font-semibold text-neutral-900 dark:text-neutral-100">{{ formatCents(item.price) }}</span>
            </span>
            <span><span class="text-neutral-500 dark:text-neutral-400">Preço final:</span>
              <span class="ml-1 font-mono font-bold text-neutral-900 dark:text-neutral-100">{{ formatCents(item.sellingPrice) }}</span>
            </span>
          </div>
        </div>

        <table class="w-full table-fixed border-collapse">
          <colgroup>
            <col style="width:140px" />
            <col style="width:30%" />
            <col />
            <col style="width:140px" />
          </colgroup>
          <thead>
            <tr class="border-b border-neutral-200 dark:border-neutral-700">
              <th class="px-2.5 pb-2.5 pt-2 text-left text-xs font-extrabold uppercase tracking-wider text-neutral-500 dark:text-neutral-400">Tipo</th>
              <th class="px-2.5 pb-2.5 pt-2 text-left text-xs font-extrabold uppercase tracking-wider text-neutral-500 dark:text-neutral-400">Nome</th>
              <th class="px-2.5 pb-2.5 pt-2 text-left text-xs font-extrabold uppercase tracking-wider text-neutral-500 dark:text-neutral-400">Descrição</th>
              <th class="px-2.5 pb-2.5 pt-2 text-left text-xs font-extrabold uppercase tracking-wider text-neutral-500 dark:text-neutral-400">Ajuste</th>
            </tr>
          </thead>
          <tbody>
            @for (adj of item.adjustments; track $index) {
              <tr class="border-b border-neutral-200 dark:border-neutral-700">
                <td class="p-2.5 align-top text-sm text-neutral-900 dark:text-neutral-100">{{ adjustmentTypeLabel(adj.type) }}</td>
                <td class="p-2.5 align-top text-sm text-neutral-900 dark:text-neutral-100">{{ adj.name ?? 'N/A' }}</td>
                <td class="p-2.5 align-top text-sm text-neutral-900 dark:text-neutral-100 break-words">{{ adj.description ?? 'N/A' }}</td>
                <td class="p-2.5 align-top text-sm">
                  <span class="font-mono font-semibold" [ngClass]="adjClass(adj.value)">{{ formatAdjustment(adj.value) }}</span>
                </td>
              </tr>
            }
          </tbody>
          <tfoot>
            <tr class="border-t-2 border-neutral-300 dark:border-neutral-600">
              <td colspan="3" class="p-3"></td>
              <td class="p-3">
                <span class="font-mono font-bold" [ngClass]="adjClass(totalAdjustments())">{{ formatAdjustment(totalAdjustments()) }}</span>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div class="flex justify-end gap-2 border-t border-neutral-200 px-5 py-3 dark:border-neutral-700">
        <app-button color="neutral" size="small" (buttonClick)="close()">Fechar</app-button>
      </div>
    </div>
  </div>
}
